export function upcomingEventSlider(){
    $(".upcoming-event-slider").slick({
        fade: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
        dots: true,
        prevArrow: `<button type='button' class='slick-prev'>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.67285 12.4199L7.49285 13.5999L0.892851 6.9999L7.49285 0.399902L8.67285 1.5799L3.25285 6.9999L8.67285 12.4199Z" fill="white"/>
                </svg>
        </button>`,
        nextArrow: `<button type='button' class='slick-next'>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.327148 12.4199L1.50715 13.5999L8.10715 6.9999L1.50715 0.399902L0.327148 1.5799L5.74715 6.9999L0.327148 12.4199Z" fill="white"/>
                </svg>
            </button>`
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/upcomingEventSlider.js